import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

const ButtonWrapper = ({
  blok,
  layoutProps = false,
  isSubmitting,
  season,
  destination,
}) => {
  const buttonArrow = {
    // FIXME: Right and down arrow HTML entities. Maybe change these to SVG later?
    arrow: <>&rarr;</>,
    arrowRight: <>&rarr;</>,
    arrowDown: <>&darr;</>,
  };

  // >--- --- --- --- --- TailwindCSS utility classes
  const buttonStyles = {
    redBtnWhiteTxt: 'bg-thunderbird hover:bg-[#b50d0e] text-white',
    greenBtnWhiteTxt: 'bg-limeade hover:bg-[#367d02] text-white',
    yellowBtnBlackTxt: 'bg-candlelight hover:bg-[#ebca0c] text-black',
    whiteBtnBlackTxt:
      'bg-white text-black hover:bg-[#cccccc] hover:text-white border border-black',
  };

  const buttonSizes = {
    btnSmall: 'w-1/4 min-w-[80px] p-1',
    btnMedium: 'w-1/2 min-w-[160px] p-2',
    btnLarge: 'w-full p-2',
  };

  const buttonTextSizes = {
    small: 'text-sm md:text-base',
    medium: 'text-base md:text-lg',
    large: 'text-xl md:text-2xl',
  };

  const buttonTextLayout = {
    arrow: 'justify-center',
    arrowRight: 'justify-between',
    arrowDown: 'justify-center',
  };

  const buttonSize = buttonSizes[blok.size];

  // >--- --- --- --- --- TailwindCSS utility classes

  const buttonParams = {
    buttonStyle: { style: blok.style, colorScheme: buttonStyles[blok.style] },
    buttonTextSize: buttonTextSizes[blok.text_size],
    textLayout: buttonTextLayout[blok.arrow],
    buttonLabel: blok.name,
    arrow: buttonArrow[blok.arrow],
    padding: buttonSize === buttonSizes.btnSmall ? 'p-2' : 'p-3',
  };

  const nestedBlok = { ...blok.types[0], ...buttonParams };

  return (
    <div
      className={`flex items-center ${buttonSize} transition-colors duration-200 my-2 ${
        layoutProps.inRichText ? '' : 'mx-4'
      }`}
      {...storyblokEditable(blok)}
    >
      <StoryblokComponent
        key={nestedBlok._uid}
        blok={nestedBlok}
        isSubmitting={isSubmitting}
        season={season}
        destination={destination}
      />
    </div>
  );
};

export default ButtonWrapper;
